import { useEffect, useState } from 'react';
import { Toolbar } from './Toolbar';
import { TableLegend } from './TableLegend';

export const TableActions = (props: TableActionProps) => {
  const {
    csvName,
    customTool,
    data,
    disableToolbar = false,
    displayData,
    externalFilter,
    expandSearch,
    filteredColumns,
    filteredData,
    legendData,
    legendFromColumn,
    loading,
    formatters,
    onClearFilter,
    searchValue,
    setFilteredColumns,
    setFilteredData,
    setSearchValue,
    tools,
  } = props;
  const [legendFilter, setLegendFilter] = useState('All');

  useEffect(() => {
    handleChange('All');
  }, [legendFromColumn, externalFilter]);

  const handleChange = (selection: string) => {
    setLegendFilter(selection);

    if (selection !== '' && selection !== 'All')
      setFilteredData(data.filter((d) => d[legendFromColumn] === selection));
    else setFilteredData(data);
  };

  return (
    <div className="flex flex-wrap justify-center md:justify-between items-center gap-4">
      {customTool ? (
        <div className="order-2 md:order-first">{customTool}</div>
      ) : null}
      {legendData.length && !Array.isArray(externalFilter) && !loading ? (
        <TableLegend
          data={legendData}
          externalFilter={externalFilter}
          onClearFilter={onClearFilter}
          onChange={handleChange}
          value={legendFilter}
        />
      ) : null}
      <div className="ml-auto order-last">
        {!disableToolbar ? (
          <Toolbar
            csvName={csvName}
            data={data}
            displayData={displayData}
            expandSearch={expandSearch}
            filteredColumns={filteredColumns}
            filteredData={filteredData}
            loading={loading}
            formatters={formatters}
            searchValue={searchValue}
            setFilteredColumns={setFilteredColumns}
            setFilteredData={setFilteredData}
            setSearchValue={setSearchValue}
            tools={tools}
          />
        ) : null}
      </div>
    </div>
  );
};
